import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkSpinner3Component } from './sk-spinners/sk-spinner-3.component';
import { AsyncResultComponent } from './async-result/async-result.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SkSpinner3Component, AsyncResultComponent],
  exports: [SkSpinner3Component, AsyncResultComponent],
})
export class ProgressModule {}
